module.exports = __webpack_public_path__ + "img/Bomberos.9b221760.webp";